@if (modus() == 'vis') {
  <div class="vis">
    <a [href]="eksisterendeLenke().adresse" target="_blank" referrerpolicy="no-referrer" class="adresse" matTooltip="{{'Åpne lenke i nytt vindu'|translate}}">
      <mat-icon>open_in_new</mat-icon>
      <span data-testid="adresse">
        @if (eksisterendeLenkeErIntern()) {
          @if (lastingAvInternlenkeSomTreffFeilet()) {
            <!-- dersom vi ikke klarer å hente indeks-innslag fra server viser vi eksisterende lenketekst -->
            {{ eksisterendeLenke().lenketekst }}
          } @else if (eksisterendeInternlenkeSomTreff() == null) {
            <!-- viser spinner mens vi henter indeks-innslag fra serer -->
            <span class="laster-lenkeinfo">
              <mat-progress-spinner mode="indeterminate" diameter="15"/>
              {{ 'Henter lenkeinformasjon'|translate }}
            </span>
          } @else {
            <!-- viser lenketekst basert på indeks-innslag hentet fra server - dersom dette lot seg gjøre -->
            {{ eksisterendeInternlenkeSomLenketekst() }}
          }
        } @else {
          {{ eksisterendeLenke().adresse }}
        }
      </span>
    </a>
    @if (!kunVisModus()) {
      <button mat-icon-button type="button" (click)="rediger()" class="mat-medium-icon-button" matTooltip="{{'Rediger lenke'}}" data-testid="rediger">
        <mat-icon inline="true">edit</mat-icon>
      </button>
      <button mat-icon-button type="button" (click)="slett()" class="mat-medium-icon-button" matTooltip="{{'Slett lenke'}}" data-testid="slett">
        <mat-icon>delete</mat-icon>
      </button>
    }
    @if (eksisterendeLenkeErIntern()) {
      @if (eksisterendeInternlenkeSomTreff() != null && stoetterForhaandsvisning(eksisterendeInternlenkeSomTreff()!)) {
        <button mat-icon-button
                type="button"
                (click.stopp)="visForhaandsvisning(eksisterendeInternlenkeSomTreff()!, $event)"
                class="mat-medium-icon-button"
                matTooltip="{{'Forhåndsvisning av lenke'}}">
          <mat-icon>info</mat-icon>
        </button>
      }
    }
    @if (!kunVisModus() && eksisterendeInternlenkeHarAvvikendeLenketekst()) {
      <button mat-button
              type="button"
              (click)="oppdaterInternlenkeLenketekst()"
              matTooltip="{{'nåværende lenketekst \"{aktiv}\" er ikke den samme som foreslått \"{generert}\" '|translate: {aktiv: eksisterendeLenke().lenketekst, generert:eksisterendeInternlenkeSomLenketekst()} }}"
              data-testid="oppdater-lenketekst">
        {{ 'Oppdater lenketekst'|translate }}
      </button>
    }
    @if (lastingAvInternlenkeSomTreffFeilet()) {
      <mat-icon matTooltip="{{ 'Informasjonen lenken peker til er enten slettet eller du mangler tilgang'|translate }}">warning</mat-icon>
    }
  </div>

} @else {
  <!-- modus = ny/rediger -->
  @let viserValideringsfeil = adresseErAntattEkstern() && skjema.controls.adresse.errors?.ugyldigUrl;
  <div class="rediger">
    <span class="adresse-lenketekst">
      <span class="adresse">
        <mat-icon inline="false">link</mat-icon>
        <input (paste)="vedLimInn($event)"
               (keyup.enter)="registrer()"
               [formControl]="skjema.controls.adresse"
               [placeholder]="adressefeltPlaceholder()"
               autoSizeInput
               [minWidth]="320"
               data-testid="adressefelt"
               #adressefelt>
      </span>
      @if (viserValideringsfeil) {
        <div class="hint valideringsfeil">
          {{ 'Adressen er ikke gyldig. Merk at adressen må starte med https://'|translate }}
        </div>
      }
      @if (!viserValideringsfeil && adresseHarForFaaTegnForSoek() && !adresseErAntattEkstern()) {
        <div class="hint">
          {{ 'Skriv inn minst 3 tegn for å søke'|translate }}
        </div>
      }
    </span>
    <span class="handlinger">
      <button mat-stroked-button color="primary" type="button" (click)="registrer()" [disabled]="skjema.invalid" data-testid="registrer">
        @if (modus() == 'ny') {
          {{ 'Sett inn'|translate }}
        } @else {
          {{ 'Oppdater'|translate }}
        }
      </button>
      <button mat-icon-button type="button" (click)="avbryt()" class="mat-medium-icon-button" data-testid="avbryt">
        <mat-icon>close</mat-icon>
      </button>
    </span>
  </div>

  @if (!viserValideringsfeil && this.eksisterendeLenke().lenketekst != null && lenketekstAvvikerFraRedigertAdresse()) {
    <mat-slide-toggle [formControl]="oppdaterLenketekstKontroll" matTooltip="{{ 'Endrer lenketekst til {lenketekst}'|translate : {lenketekst: adressefeltVerdi()} }}" @fadeInn>
      {{ 'Oppdater lenketekst til'|translate }} <span class="lenketekst">{{ adressefeltVerdi() }}</span>
    </mat-slide-toggle>
  }

  <div class="søkeresultat" [style.display]="viserSoekeresultat() ? 'block' : 'none'">
    <div class="blokkoverskrift">{{ 'Begrens søket til'|translate }}</div>
    <velg-soekbare-entiteter [skjemakontroll]="skjema.controls.inkluderteTyper" [tilgjengeligeTyper]="tilgjengeligeTyper"/>
    <velg-soekeperiode [skjemakontroll]="skjema.controls.periode" (click)="$event.stopPropagation()"/>

    <mat-selection-list [formControl]="valgtTreffKontroll" multiple="false" [hideSingleSelectionIndicator]="true" data-testid="soekeresultatListing" #soekeresultatListing>
      @let treff = valgtTreff() ?? eksisterendeInternlenkeSomTreff()!;
      @if (treff != null) {
        <div class="blokkoverskrift">{{ 'Valgt internlenke'|translate }}</div>
        <mat-list-option [value]="treff" class="valgt-treff">
          <soek-vis-treff [treff]="treff" visTekstmatch="false">
            @if (stoetterForhaandsvisning(treff)) {
              <button mat-icon-button type="button" (click.stopp)="visForhaandsvisning(treff, $event)" data-testid="knapp-info" matTooltip="{{'Forhåndsvisning av treffet'}}">
                <mat-icon>info</mat-icon>
              </button>
            }
          </soek-vis-treff>
        </mat-list-option>
      }
      <div class="blokkoverskrift">
        @if (soekPaagaar()) {
          <mat-progress-spinner mode="indeterminate" diameter="20"/>
          {{ 'søker...'|translate }}
        } @else if (soekeresultat().length == 0 && !adresseHarForFaaTegnForSoek()) {
          {{ 'Ingen treff'|translate }}
        } @else if (!adresseHarForFaaTegnForSoek()) {
          {{ 'Viser {antall} treff'|translate :{antall: soekeresultat().length} }}
        }
      </div>

      <!-- lister søkeresultat -->
      @for (treff of soekeresultat(); track treff._id) {
        <mat-list-option [value]="treff">
          <soek-vis-treff [treff]="treff">
            @if (stoetterForhaandsvisning(treff)) {
              <button mat-icon-button type="button" (click.stopp)="visForhaandsvisning(treff, $event)" data-testid="knapp-info" matTooltip="{{'Forhåndsvisning av treffet'}}">
                <mat-icon>info</mat-icon>
              </button>
            }
          </soek-vis-treff>
        </mat-list-option>
      }
    </mat-selection-list>

  </div>
}


<ng-template #forhaandsvisningFragment>
  @switch (forhaandsvisningAvTreff()?._type) {
    @case (entitettyper.sak) {
      <div class="forhåndsvisning-sak">
        <button mat-mini-fab color="secondary" type="button" (click.stopp)="lukkForhaandsvisning()" class="lukk" data-testid="lukk">
          <mat-icon>close</mat-icon>
        </button>
        <div class="møte">
          {{ forhaandsvisningAvTreffSomSak().forelderinfo.moete }} {{ forhaandsvisningAvTreffSomSak().forelderinfo.moetenummer }}, {{ forhaandsvisningAvTreffSomSak().dato|millissidenepochSomZonedDateTime|zoneddatetimeSomPlaindate|plaindate }}
        </div>
        <sak-vis-kompakt [sakId]="forhaandsvisningAvTreff()!._id"/>
      </div>
    }
    @case (entitettyper.opplastetDokumentVersjon) {
      <div class="forhåndsvisning-dokument">
        <!-- visDetaljerForDokumentversjon blir satt asynkront, må vente til informasjon har blitt lastet -->
        @if (forhaandsvisningAvTreffSomDokumentversjon()) {
          <dokument-inline-pdfviser [dokumentversjon]="forhaandsvisningAvTreffSomDokumentversjon()!" (click.stopp)="lukkForhaandsvisning()"/>
        }
      </div>
    }
  }
</ng-template>
